import { GOOGLE_TTS_API_KEY } from "./constant";

export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

export const synthesizeSpeech = async (text, name = 'en-US-Wavenet-F') => {
  const API_KEY = GOOGLE_TTS_API_KEY;
  const url = `https://texttospeech.googleapis.com/v1/text:synthesize?key=${API_KEY}`;
  const body = {
    input: { text: text },
    voice: { languageCode: 'ar-XA', name: name },
    audioConfig: { audioEncoding: 'MP3' },
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    });

    const result = await response.json();
    return result; // contains audioContent (base64 MP3)
  } catch (error) {
    console.error('Error synthesizing speech:', error);
    throw error;
  }
};

export const isMostlyArabic = (text) => {
  if (text) {
    const cleanText = text.replace(/\s+/g, "");

    if (cleanText.length === 0) return false;
    const arabicRegex = /[\u0600-\u06FF]/g;
    const arabicMatches = cleanText.match(arabicRegex);

    const arabicCount = arabicMatches ? arabicMatches.length : 0;

    // Return true if more than 50% of the text is Arabic
    return arabicCount > cleanText.length / 2;
  }
};


export const stripHtml = (html) => {
  if (!html) return "";
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || "";
};
